import withEntity from '@/entity/components/with-entity';
import OnboardingData from './onboarding-data';

export default withEntity(OnboardingData);
